module.exports = __webpack_public_path__ + "static/media/chevron-right.5cdcf42b.svg";